const customerResetByUrlMutation = /* GraphQL */ `
  mutation customerResetByUrl($resetUrl: URL!, $password: String!) {
  customerResetByUrl(password: $password, resetUrl: $resetUrl) {
    customer {
      id
    }
    customerAccessToken {
      accessToken
    }
    customerUserErrors {
      code
      field
      message
    }
  }
}
`
export default customerResetByUrlMutation
